<template>
<div class="agreement">
    <div class="title">{{ sdkList.title }}</div>
    <div class="content">
        <div class="sub-text-con-1" v-for="(con1,c1) in sdkList.content" :key="c1">
            <div class="sub-text-1" v-html="con1.text"></div>
            <div class="sub-text-con-2" v-for="(con2, c2) in con1.subText" :key="c2">
                <div class="sub-text-2" v-html="con2.text"></div>
                <div class="sub-text-con-3" v-for="(con3, c3) in con2.subText" :key="c3">
                    <div class="sub-text-3" v-html="con3.text"></div>
                    <div class="sub-text-con-4" v-for="(con4, c4) in con3.subText" :key="c4">
                        <div class="sub-text-4" v-html="con4.text"></div>
                        <div class="sub-text-con-5" v-for="(con5, c5) in con4.subText" :key="c5">
                            <div class="sub-text-5" v-html="con5.text"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import sdkList from './data/sdkList'
export default {
  data(){
    return {
      sdkList
    }
  },
  created() {
    document.title = '第三方SDK目录'
  },
}
</script>

<style lang="less" scoped>
@import "./style/agreement.less";
</style>
